/**
 * @fileoverview POST handler for the "/companies/:company_id/sender_verification/setup_rdns" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdSenderVerificationSetupRdnsCacheKeys } from "./constants";
import type {
  PostCompaniesCompanyIdSenderVerificationSetupRdnsProps,
  CompaniesCompanyIdSenderVerificationSetupRdnsResult,
} from "./types";

export const postCompaniesCompanyIdSenderVerificationSetupRdns = reactQueryMutationAdapter(
  companiesCompanyIdSenderVerificationSetupRdnsCacheKeys,
  (
    props: PostCompaniesCompanyIdSenderVerificationSetupRdnsProps
  ): Promise<CompaniesCompanyIdSenderVerificationSetupRdnsResult> => {
    return fetch(
      `/companies/${props.companyId}/sender_verification/setup_rdns`,
      "POST",
      props,
      {},
      { propagateFetchRequestError: false }
    );
  }
);
